<template>
  <div>
    <p v-if="message !== null">
      {{message}}
    </p>

    <table
      v-if="orderPreviews !== null && orderPreviews.length > 0"
      class="table text-nowrap"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Order</th>
        </tr>
      </thead>
      <tr
        v-for="orderPreview in orderPreviews"
        :key="orderPreview.id"
      >
        <td>
          <span class="custom-code">{{orderPreview.id}}</span>
        </td>
      </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';

import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'PlayerOrders',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,

      orderPreviews: null,
    };
  },

  computed: {
    message() {
      if(this.orderPreviews !== null && this.orderPreviews.length === 0) {
        return 'No orders.';
      }
      return null;
    },
  },

  created() {
    this.loadOrderPreviews();
  },

  methods: {
    loadOrderPreviews() {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      const url = `/player/${this.playerId}/orders`;
      HTTP.get(url)
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.orderPreviews = data;
      })
      .catch(e => {
        this.isLoading = false;
        notifier.showError(e.response.data, {sender: this});
      }); 
    },
  },
};
</script>
